import { render, staticRenderFns } from "./Bidbonds.vue?vue&type=template&id=b0cbb18c"
import script from "./Bidbonds.vue?vue&type=script&lang=js"
export * from "./Bidbonds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports